export function parseTaskQuickCapture(value: unknown): boolean {
  return value === true;
}
